export default {
  title: 'Merci {{firstName}} {{lastName}}',
  subTitle: 'Votre réservation est confirmée.',
  orderedBy: 'réservé par: {{type}}',
  seat: 'Siège {{seat}}',
  paymentTypes: {
    creditCard: 'Carte de crédit',
    correspondance: 'Correspondance',
    opusCard: 'Carte OPUS',
    cashOnBoard: 'Perception (Argent comptant)',
    free: 'Free',
    opusCardMensuel: 'Carte OPUS - Mensuel',
    opusCardPassage: 'Carte OPUS - Passage',
    cpoPassage: 'Carte a puce occasionnelle (CPO) - Passage',
  },
};
